module.exports = __webpack_public_path__ + "static/media/LadyShark.663e96f0.png";